/**
 * Internal dependencies
 */
import SVGCurve1 from './images/curve-1.svg'
import SVGCurve1Shadow from './images/curve-1-shadow.svg'
import SVGCurve1Inverted from './images/curve-1-inverted.svg'
import SVGCurve1InvertedShadow from './images/curve-1-inverted-shadow.svg'
import SVGCurve2 from './images/curve-2.svg'
import SVGCurve2Shadow from './images/curve-2-shadow.svg'
import SVGCurve2Inverted from './images/curve-2-inverted.svg'
import SVGCurve2InvertedShadow from './images/curve-2-inverted-shadow.svg'
import SVGCurve3 from './images/curve-3.svg'
import SVGCurve3Shadow from './images/curve-3-shadow.svg'
import SVGCurve3Inverted from './images/curve-3-inverted.svg'
import SVGCurve3InvertedShadow from './images/curve-3-inverted-shadow.svg'
import SVGRounded1 from './images/rounded-1.svg'
import SVGRounded1Shadow from './images/rounded-1-shadow.svg'
import SVGRounded1Inverted from './images/rounded-1-inverted.svg'
import SVGRounded1InvertedShadow from './images/rounded-1-inverted-shadow.svg'
import SVGRounded2 from './images/rounded-2.svg'
import SVGRounded2Shadow from './images/rounded-2-shadow.svg'
import SVGRounded2Inverted from './images/rounded-2-inverted.svg'
import SVGRounded2InvertedShadow from './images/rounded-2-inverted-shadow.svg'
import SVGRounded3 from './images/rounded-3.svg'
import SVGRounded3Shadow from './images/rounded-3-shadow.svg'
import SVGRounded3Inverted from './images/rounded-3-inverted.svg'
import SVGRounded3InvertedShadow from './images/rounded-3-inverted-shadow.svg'
import SVGSlant1 from './images/slant-1.svg'
import SVGSlant1Shadow from './images/slant-1-shadow.svg'
import SVGSlant1Inverted from './images/slant-1-inverted.svg'
import SVGSlant1InvertedShadow from './images/slant-1-inverted-shadow.svg'
import SVGSlant2 from './images/slant-2.svg'
import SVGSlant2Shadow from './images/slant-2-shadow.svg'
import SVGSlant2Inverted from './images/slant-2-inverted.svg'
import SVGSlant2InvertedShadow from './images/slant-2-inverted-shadow.svg'
import SVGStraight1 from './images/straight-1.svg'
import SVGStraight1Shadow from './images/straight-1-shadow.svg'
import SVGWave1 from './images/wave-1.svg'
import SVGWave1Shadow from './images/wave-1-shadow.svg'
import SVGWave1Inverted from './images/wave-1-inverted.svg'
import SVGWave1InvertedShadow from './images/wave-1-inverted-shadow.svg'
import SVGWave2 from './images/wave-2.svg'
import SVGWave2Shadow from './images/wave-2-shadow.svg'
import SVGWave2Inverted from './images/wave-2-inverted.svg'
import SVGWave2InvertedShadow from './images/wave-2-inverted-shadow.svg'
import SVGWave3 from './images/wave-3.svg'
import SVGWave3Shadow from './images/wave-3-shadow.svg'
import SVGWave3Inverted from './images/wave-3-inverted.svg'
import SVGWave3InvertedShadow from './images/wave-3-inverted-shadow.svg'
import SVGWave4 from './images/wave-4.svg'
import SVGWave4Shadow from './images/wave-4-shadow.svg'
import SVGWave4Inverted from './images/wave-4-inverted.svg'
import SVGWave4InvertedShadow from './images/wave-4-inverted-shadow.svg'

export const separators = {
	'wave-1': {
		default: {
			shape: SVGWave1,
			shadow: SVGWave1Shadow,
		},
		inverted: {
			shape: SVGWave1Inverted,
			shadow: SVGWave1InvertedShadow,
		},
	},
	'wave-2': {
		default: {
			shape: SVGWave2,
			shadow: SVGWave2Shadow,
		},
		inverted: {
			shape: SVGWave2Inverted,
			shadow: SVGWave2InvertedShadow,
		},
	},
	'wave-3': {
		default: {
			shape: SVGWave3,
			shadow: SVGWave3Shadow,
		},
		inverted: {
			shape: SVGWave3Inverted,
			shadow: SVGWave3InvertedShadow,
		},
	},
	'wave-4': {
		default: {
			shape: SVGWave4,
			shadow: SVGWave4Shadow,
		},
		inverted: {
			shape: SVGWave4Inverted,
			shadow: SVGWave4InvertedShadow,
		},
	},
	'curve-1': {
		default: {
			shape: SVGCurve1,
			shadow: SVGCurve1Shadow,
		},
		inverted: {
			shape: SVGCurve1Inverted,
			shadow: SVGCurve1InvertedShadow,
		},
	},
	'curve-2': {
		default: {
			shape: SVGCurve2,
			shadow: SVGCurve2Shadow,
		},
		inverted: {
			shape: SVGCurve2Inverted,
			shadow: SVGCurve2InvertedShadow,
		},
	},
	'curve-3': {
		default: {
			shape: SVGCurve3,
			shadow: SVGCurve3Shadow,
		},
		inverted: {
			shape: SVGCurve3Inverted,
			shadow: SVGCurve3InvertedShadow,
		},
	},
	'slant-1': {
		default: {
			shape: SVGSlant1,
			shadow: SVGSlant1Shadow,
		},
		inverted: {
			shape: SVGSlant1Inverted,
			shadow: SVGSlant1InvertedShadow,
		},
	},
	'slant-2': {
		default: {
			shape: SVGSlant2,
			shadow: SVGSlant2Shadow,
		},
		inverted: {
			shape: SVGSlant2Inverted,
			shadow: SVGSlant2InvertedShadow,
		},
	},
	'straight-1': {
		default: {
			shape: SVGStraight1,
			shadow: SVGStraight1Shadow,
		},
		inverted: {
			shape: SVGStraight1,
			shadow: SVGStraight1Shadow,
		},
	},
	'rounded-1': {
		default: {
			shape: SVGRounded1,
			shadow: SVGRounded1Shadow,
		},
		inverted: {
			shape: SVGRounded1Inverted,
			shadow: SVGRounded1InvertedShadow,
		},
	},
	'rounded-2': {
		default: {
			shape: SVGRounded2,
			shadow: SVGRounded2Shadow,
		},
		inverted: {
			shape: SVGRounded2Inverted,
			shadow: SVGRounded2InvertedShadow,
		},
	},
	'rounded-3': {
		default: {
			shape: SVGRounded3,
			shadow: SVGRounded3Shadow,
		},
		inverted: {
			shape: SVGRounded3Inverted,
			shadow: SVGRounded3InvertedShadow,
		},
	},
}
